import { render, staticRenderFns } from "./BotaoRastreabilidadeBungeSubEmpresa.vue?vue&type=template&id=aca4a586&lang=pug"
import script from "./BotaoRastreabilidadeBungeSubEmpresa.vue?vue&type=script&lang=js"
export * from "./BotaoRastreabilidadeBungeSubEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports